export default __webpack_public_path__ + "static/media/Gotham-Black.c9e42599.otf";